<template>
  <Modal
    :title="$t('create_warehouse')"
    modalId="create-modal"
    @submit="submitWarehouse"
    @cancel="resetForm"
  >
    <form @submit.prevent="submitWarehouse">
      <div class="mb-3">
        <label class="form-label">
          {{ $t('warehouse_name') }} <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          v-model="warehouse.name"
          class="form-control"
        />
        <div v-if="errors.name" class="text-danger mt-2">
          <span>{{ errors.name }}</span>
        </div>

        <label class="form-label">
          {{ $t('warehouse_address') }}
        </label>
        <input
          type="text"
          v-model="warehouse.address"
          class="form-control"
        />
        <div v-if="errors.address" class="text-danger mt-2">
          <span>{{ errors.address }}</span>
        </div>

        <label class="form-label">
          {{ $t('warehouse_phone_number') }}
        </label>
        <input
          type="text"
          v-model="warehouse.phone_number"
          class="form-control"
        />
        <div v-if="errors.phone_number" class="text-danger mt-2">
          <span>{{ errors.phone_number }}</span>
        </div>
      </div>
      <div v-if="errorMessage" class="text-danger mt-2">
        {{ errorMessage }}
      </div>
    </form>
  </Modal>
</template>

<script>
import Modal from "@/components/common/Modal.vue"; // Import Modal component
import apiUrls from "../../../urls"; // Import API URLs

export default {
   components: {
      Modal,
    },
   data() {
    return {
      warehouse: {
        name: '',
        address: '',
        phone_number: '',
      },
      errors: {},
      errorMessage: "",
    };
  },

  methods: {
      async submitWarehouse() {
        this.errors = {};  // Reset errors
        this.errorMessage = "";  // Reset general error message

        // Frontend validation
        if (!this.warehouse.name.trim()) this.errors.name = this.$t('error.required');

        // Phone number is optional but should be valid if entered
        if (this.warehouse.phone_number.trim()) {
          const phoneRegex = /^[0-9]{10,15}$/;
          if (!phoneRegex.test(this.warehouse.phone_number.trim())) {
            this.errors.phone_number = this.$t('error.invalid_phone');
          }
        }

        if (Object.keys(this.errors).length > 0) return; // Stop if validation fails

        try {
          const formData = new FormData();
          Object.keys(this.warehouse).forEach((key) => {
            formData.append(key, this.warehouse[key]);
          });
          // Send API request
          const response = await this.$axios.post(apiUrls.inventory_warehouse.post, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          // Close modal after success
          const modal = document.getElementById("create-modal1");
          const modalInstance = bootstrap.Modal.getInstance(modal);
          if (modalInstance) modalInstance.hide();

          // Emit event to update parent component
          this.$emit("create_success", response.data);

          this.resetForm();
        } catch (error) {
          if (error.response?.data?.error) {
            this.errorMessage = error.response.data.error;
          }

          // Handle field-specific errors dynamically
          if (error.response?.data?.errors) {
            this.errors = error.response.data.errors; // Dynamically set field errors
          }
        }
      },
      resetForm() {
      // Reset form fields and errors
      this.warehouse = { id: null, name: '', address: '', phone_number: '' };
      this.errors = {};
      this.errorMessage = "";
    }
  },
};
</script>
